function xcaptchaSetCaptchaImage(solutionUrl, imageUrl) {
    $.ajax(
        {
            url: solutionUrl,
            cache: false
        }).done(function (data) {

            var src = imageUrl + data;

            $('#-xcaptcha-hidden').val(data);
            $('#-xcaptcha-image').attr("src", src);

        });
}


$('#-xcaptcha-refresh').click(function () {
    xcaptchaChangeCaptchaImage();
    return false;
});
       